export default __webpack_public_path__ + "static/media/weatherdash.b5503843.jpg";